import { render, staticRenderFns } from "./DiagnosticHypothesisPanel.vue?vue&type=template&id=b708ef20&scoped=true&"
import script from "./DiagnosticHypothesisPanel.vue?vue&type=script&lang=js&"
export * from "./DiagnosticHypothesisPanel.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticHypothesisPanel.vue?vue&type=style&index=0&id=b708ef20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b708ef20",
  null
  
)

export default component.exports